export enum SocialAuthProviders {
  GOOGLE = 'google-oauth2',
  GITHUB = 'github',
  FACEBOOK = 'facebook',
  LINKEDIN = 'linkedin',
}
